export default import.meta.ROLLDOWN_FILE_URL_52sasY4xo7eTGkAzeu_5nQ